import {Matcher} from '@/lib/axiosAddTransforms'
import {CreateBizPayload, UpdatePayload} from '@/store/modules/biz/types'

const matchers: Matcher[] = [
  {
    test: /^\/bizs\/\$id\/?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {id} = payload.data
        payload.url = `/bizs/${id}`
        return payload
      },
      response: (data) => {
        if(!data || !data.id) {
          return data
        }
        return bizResponse(data)
      },
    },
  },
  {
    // create biz
    test: /^\/bizs\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        payload.url = '/sign-up/biz'
        const {data} = payload
        payload.data = bizCreateRequest(data)
        return payload
      },
      response: (data) => {
        if(!data || !data.id) {
          return data
        }
        return bizResponse(data)
      },
    },
  },
  {
    // update biz
    test: /^\/bizs\/\$id\/?/,
    method: 'patch',
    transform: {
      request: (payload) => {
        const {data} = payload
        const {id} = data
        payload.data = bizUpdateRequest(data)
        payload.url = `/bizs/${id}`
        return payload
      },
      response: (data) => {
        if(!data || !data.id) {
          return data
        }
        return bizResponse(data)
      },
    },
  },
]

const bizResponse = (data) => {
  const {
    id,
    name,
    representative,
    registrationNumber,
    corporateRegistrationNumber,
    isCorporate,
    phoneNumber,
    businessType,
    businessClass,
    fullAddress,
    taxRegistrationNumber,
    email,
    verified,
    hasExpiredCertificate,
  } = data
  const ownerName = representative ? representative.name : null
  const ownerRegistrationNumber = representative ? representative.registrationNumber : null
  const ownerEmail = representative ? representative.email : null
  return {
    id: String(id),
    name,
    bizRegistrationNumber: registrationNumber,
    isCorporate,
    ownerName,
    corporateRegistrationNumber,
    ownerRegistrationNumber,
    bizPhoneNumber: phoneNumber,
    ownerEmail,
    bizType: businessType,
    bizClass: businessClass,
    address: fullAddress,
    taxRegistrationNumber,
    email,
    otherBizVerified: verified === false,
    hasExpiredCertificate,
  }
}

const bizCreateRequest = (data: CreateBizPayload) => {
  const {
    name, bizPhoneNumber, bizRegistrationNumber, corporateRegistrationNumber, isCorporate,
    ownerName, ownerRegistrationNumber, ownerEmail,
  } = data
  return {
    name,
    phoneNumber: bizPhoneNumber,
    registrationNumber:bizRegistrationNumber,
    corporateRegistrationNumber,
    isCorporate,
    representative: {
      name: ownerName,
      registrationNumber: ownerRegistrationNumber,
      email: ownerEmail,
    },
  }
}

const bizUpdateRequest = (data: UpdatePayload) => {
  const {
    ownerName, address, bizClass, bizType, email,
    taxRegistrationNumber,
  } = data

  return {
    representativeName: ownerName,
    fullAddress: address,
    businessClass: bizClass,
    businessType: bizType,
    email: email,
    taxRegistrationNumber: taxRegistrationNumber,
  }
}

export {bizResponse, bizCreateRequest, bizUpdateRequest}

export default matchers
